import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';
import {SessionService} from '../../../core/service/session.service';
import {EventService} from '../../../core/service/event.service';
import {CloudStorageService} from '../../../core/service/cloud-storage.service';
import {SafeResourceUrl} from '@angular/platform-browser';
import {ShiyoulotService} from '../../../core/service/shiyoulot.service';
import {SaizaiSaiketsuJisshiNaiyou} from '../../interfaces/saizai-saiketsu-jisshi-naiyou';
import {exceptKeyWithOptional, yyyyMMdd} from '../../typeAliases';
import {SaizaiEvent} from '../../interfaces/saizai-event';

@Component({
  selector: 'app-saizai-event-dialog',
  templateUrl: './saizai-event-dialog.component.html',
  styleUrls: ['./saizai-event-dialog.component.scss',
    './../../layout/layout.component.scss']
})
export class SaizaiEventDialogComponent implements OnInit {
  selectedMeisais: SaizaiEvent[] = [];
  inputForm: exceptKeyWithOptional<SaizaiSaiketsuJisshiNaiyou, 'jisshiDate'> = this.eventService.getInitialSaizaiSaiketsuJisshiNaiyou();
  editEvent = false;
  willUploadFileList: any[] = [];
  willDeleteFileList: any[] = [];
  blobURL?: SafeResourceUrl;
  edukeDate: yyyyMMdd;
  constructor(@Inject(MAT_DIALOG_DATA) public data: SaizaiEvent[],
              public matDialogRef: MatDialogRef<SaizaiEventDialogComponent>,
              public commonService: CommonService,
              public sessionService: SessionService,
              public eventService: EventService,
              public shiyoulotService: ShiyoulotService,
              public cloudStorageService: CloudStorageService,) {
    this.edukeDate = this.data[0].taishouEdukeDate;
  }

  /**
   *
   */
  ngOnInit(): void {
    this.selectedMeisais = this.data;
    this.eventService.setInputForm2(this.inputForm, this.selectedMeisais[0]);
    this.eventService.updateJisshiNichirei2(this.inputForm, this.edukeDate);
    if (this.inputForm.filePath) {
      this.cloudStorageService.downLoad(this.inputForm.filePath).then(blobURL => {
        this.blobURL = this.cloudStorageService.sanitizeUrl(blobURL);
        console.log(this.blobURL);
      });
    }
  }

  /**
   *
   * @param event
   */
  showUnUploadedFile(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target && target.files) {
      this.cloudStorageService.fileToArrayBuffer(target.files[0])
        .then(blob => {
          this.blobURL = blob;
        })
        .catch(err => console.log(err));
    }
  }

  /**
   * 採材料イベント登録
   */
  register() {
    this.selectedMeisais.forEach((meisai: SaizaiEvent) => {
      this.eventService.inputForm2Event2(this.inputForm, meisai);
      if (this.willDeleteFileList.length > 0) {
        delete meisai.filePath;
      }
      console.log(meisai);
    });

    Promise.all([this.cloudStorageService.uploadAllFile(this.willUploadFileList),
      this.cloudStorageService.deleteAllFile(this.willDeleteFileList)])
      .then(() => {
        this.eventService.updateEvents(this.selectedMeisais);
        if (this.inputForm.filePath) {
          this.cloudStorageService.downLoad(this.inputForm.filePath).then(blobURL => {
            this.blobURL = this.cloudStorageService.sanitizeUrl(blobURL);
            console.log(this.blobURL);
          });
        }
      }).then(() => {
      // 成功した場合のみ true を返す
        this.commonService.onClick(this.matDialogRef, true);
      }).catch(e => {
        console.log('component promise all', e);
        alert(e);
      });
  }

  /**
   * 採材イベント取り消し
   */
  undo() {
    // TODO: PDFの削除も同時に行う必要有
    if (confirm('実施内容を取り消しますか?')) {
      this.eventService.undoEvents(this.selectedMeisais).then(() => {
        // 成功した場合のみ true を返す
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }

  /**
   * 採材イベント削除
   */
  delete() {
    if (confirm('作業を削除しますか?')) {
      this.eventService.deleteEvents(this.selectedMeisais).then(() => {
        // 成功した場合のみ true を返す
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }
}
